import React from 'react';
import { Button, Card, Container, Grid, Form, Page } from 'tabler-react';
import CardAlert from '../../Components/CardAlert';
import Input from '../../Components/Playgrond/Input';
import Logo from '../../Components/Logo';
import fetch from '../../support/fetch';
import './index.sass';

class ForgotPassword extends React.Component {
    state = {
        login: '',
        pin: '',
        alertColor: 'danger',
        alertText: '',
        workingOnPinValidation: false,
        sendedPasswordEmail: false,
        sendedPasswordEmailFailed: false,
        subscriberEmail: '',
        buttonText: 'Recuperar minha senha'
    };

    /**
     * Make a request based on a state.
     * Available states: (generatePin|validatePin)
     *
     * @param state
     */
    makeRequest = state => {

        let query;
        let variables = {};

        switch (state) {
            case 'generatePin':
                query = `mutation GeneratePinToken($document: String!) {
                    generateRecoveryPin(document: $document) {
                        success
                    }
                }`;

                variables = {
                    document: this.state.login
                };

                break;

            case 'validatePin':
                query = `query ValidatePin($document: String!, $pin: String!) {
                    validatePin(document: $document, pin: $pin) {
                        success
                    }
                }`;

                variables = {
                    document: this.state.login,
                    pin: this.state.pin
                };
                break;
            case 'recoveryPassword':
                query = `mutation GeneratePassword($document: String!) {
                    generateRecoveryPassword(document: $document) {
                        email,
                        document,
                        name
                    }
                }`;

                variables = {
                    document: this.state.login
                };

                break;
            default:
                break;
        }


        this.setState({
            showLoader: true
        });

        fetch.obj({
            query: query,
            variables: variables
        })
        .then(res => {
            if (res.hasOwnProperty('errors')) {
                // console.log(res.errors[0]);

                this.setState({
                    alertText: 'Um erro ocorreu. Por favor, tente novamente.',
                    showLoader: false,
                });

                return;
            }

            if (state === 'generatePin') {
                this.setState({
                    workingOnPinValidation: true,
                    showLoader: false,
                    buttonText: 'Validar PIN'
                });
            }

            if (state === 'validatePin') {
                this.setState({
                    workingOnPinValidation: false,
                    showLoader: false,
                    buttonText: 'Recuperar minha senha',
                    alertText: 'Seu PIN foi validado com sucesso. Siga as instruções que acabamos de te enviar por email.',
                    alertColor: 'success'
                }, () => {
                    setTimeout(() => {
                        window.location = '/';
                    }, 10000)
                });
            }

            if (state === 'recoveryPassword') {
                let email = res.data.generateRecoveryPassword.email;
                let alertText = 'Sua senha foi redefinida com sucesso. Siga as instruções que acabamos de te enviar por email.';
                let alertColor = 'success';
                let failed = false;
                if (email === null) {
                    alertText = 'Ops, não encontramos o seu registro';
                    alertColor = 'danger';
                    failed = true;
                }
                this.setState({
                    workingOnPinValidation: false,
                    sendedPasswordEmail: true,
                    subscriberEmail: email,
                    showLoader: false,
                    alertText: alertText,
                    alertColor: alertColor,
                    sendedPasswordEmailFailed: failed
                });
            }
        });
    };

    generatePinRequest = () => {
        this.makeRequest('generatePin');
    };

    validatePin = () => {
        this.makeRequest('validatePin');
    };

    generatePasswordRecoveryRequest = () => {
        this.makeRequest('recoveryPassword');
    };

    onChangeHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    };

    onSubmitHandler = e => {
        e.preventDefault();

        // Firstly generate a pin...
        // !this.state.workingOnPinValidation && this.generatePinRequest();
        !this.state.sendedPasswordEmail && this.generatePasswordRecoveryRequest();

        // after, validate a pin...
        // this.state.workingOnPinValidation && this.validatePin();
    };

    render() {
        return (
            <Page>
                <Container>
                    <Grid.Row>
                        <Grid.Col className="col-login mx-auto login">
                            <form onSubmit={this.onSubmitHandler} autoComplete="off">
                                <Logo />
                                <Card>
                                    <CardAlert color={this.state.alertColor}>{this.state.alertText}</CardAlert>

                                    <Card.Body>
                                        <h3>Recuperação de senha</h3>

                                        {
                                            ! this.state.workingOnPinValidation && ! this.state.sendedPasswordEmail &&
                                            <React.Fragment>
                                                <p className="lead">
                                                    Para começar com a recuperação de sua senha, por favor,{' '}
                                                    informe o seu CPF.
                                                </p>

                                                <Form.Group label="">
                                                    <Input
                                                        name="login"
                                                        type="tel"
                                                        size="xl"
                                                        onChange={this.onChangeHandler}
                                                        placeholder="Informe seu CPF"
                                                        disabled={this.state.showLoader}
                                                        maxLength={11}
                                                        numberOnly
                                                    />
                                                </Form.Group>
                                            </React.Fragment>
                                        }

                                        {
                                            this.state.workingOnPinValidation &&
                                            <React.Fragment>
                                                <p className="lead">
                                                    Falta pouco!<br/><br/>
                                                    Enviamos um e-mail para você, com um código de{' '}
                                                    Validação. Para continuar, informe-o no campo a seguir.
                                                </p>

                                                <Form.Group label="">
                                                    <Input
                                                        name="pin"
                                                        type="text"
                                                        size="xl"
                                                        className="text-center recovery-pin"
                                                        numberOnly
                                                        maxLength={6}
                                                        onChange={this.onChangeHandler}
                                                        placeholder="_ _ _ _ _ _"
                                                        disabled={this.state.showLoader}
                                                    />
                                                </Form.Group>
                                            </React.Fragment>
                                        }

                                        {
                                            this.state.sendedPasswordEmail &&
                                            <React.Fragment>
                                                { this.state.sendedPasswordEmailFailed &&
                                                    <p className="lead">
                                                    Erro!<br/><br/>
                                                    Parece que houve um problema.
                                                    </p>    
                                                }

                                                { ! this.state.sendedPasswordEmailFailed &&
                                                    <p className="lead">
                                                    Falta pouco!<br/><br/>
                                                    Enviamos um e-mail para você ({this.state.subscriberEmail}), com a sua nova senha.
                                                    </p>    
                                                }

                                                { ! this.state.sendedPasswordEmailFailed &&
                                                    <a href="https://wa.me/5521994765872/?text=Olá!%20Não%20tenho%20mais%20acesso%20ao%20e-mail%20de%20recuperação%20de%20senha." className="text-center small" target="_blank">
                                                        Não tenho mais acesso a este e-mail
                                                    </a> 
                                                }   
                                                
                                            </React.Fragment>
                                        }

                                        {
                                            !this.state.sendedPasswordEmail &&
                                            <Button
                                            block
                                            outline={!this.state.showLoader}
                                            loading={this.state.showLoader}
                                            disabled={this.state.showLoader}
                                            size="lg"
                                            color="primary">{this.state.buttonText}</Button>
                                        }
                                        
                                    </Card.Body>
                                </Card>

                                <a href="https://profile.ooppah.com/" className="d-block text-center small">voltar</a>
                            </form>
                        </Grid.Col>
                    </Grid.Row>
                </Container>
            </Page>
        );
    };
}

export default ForgotPassword;